<button mat-mini-fab color="accent" (click)="toggle()" class="toggle-button">
    <mat-icon>{{ expandIcon }}</mat-icon>
</button>
@if (expanded) {
    <mat-card class="flex-row">
        <mat-card-content>
            <ng-content></ng-content>
        </mat-card-content>
    </mat-card>
}
